import { useEffect, useRef, useState } from "react";

interface Props {
  /** "up" abre o popover acima do botão (barras coladas no rodapé); "down" é o padrão. */
  direction?: "up" | "down";
  buttonClassName?: string;
  /** Mostra um indicador (ex.: ponto de "novidade não lida") no botão de gatilho. */
  hasBadge?: boolean;
  title?: string;
  /** Recebe `close` pra cada item poder fechar o popover ao ser clicado. */
  children: (close: () => void) => React.ReactNode;
}

/**
 * Botão "⋯" que abre um popover com ações secundárias - usado pra tirar
 * funções menos usadas de barras de botões que não podem quebrar linha
 * (toolbar do composer, ações da conversa) sem estourar a largura da tela.
 */
export function OverflowMenu({ direction = "down", buttonClassName, hasBadge, title, children }: Props) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  return (
    <div className="overflow-menu-wrap" ref={ref}>
      <button
        type="button"
        className={buttonClassName ?? "action-btn"}
        onClick={() => setOpen((v) => !v)}
        title={title ?? "Mais opções"}
        aria-label={title ?? "Mais opções"}
        aria-expanded={open}
      >
        <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor" aria-hidden>
          <circle cx="3" cy="8" r="1.4" />
          <circle cx="8" cy="8" r="1.4" />
          <circle cx="13" cy="8" r="1.4" />
        </svg>
        {hasBadge && <span className="changelog-dot" aria-hidden />}
      </button>
      {open && <div className={`overflow-menu-popover ${direction === "up" ? "up" : "down"}`}>{children(() => setOpen(false))}</div>}
    </div>
  );
}
